/**
 * @class AderantAzureStorageError 
 * @classdesc Error thrown when there is an issue with the credentials provided to 
 * the storage client or when the user has not provided 
 * a required parameter for an Azure Storage CRUD operation.
 * @param {string} message - The error message.
 *
*/
class AderantAzureStorageError extends Error {
    constructor(message) {
        super(message);
    }
}



module.exports = {
    AderantAzureStorageError
}